/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { CORE_SERVICE_PATH } from './constants';
import CoreServiceAccessGuard from './CoreServiceAccessGuard';
import CoreServicePage from './CoreServicePage';

/**
 * Only a direct link leads here: the page is absent from every menu. Only the CTO gets in: everybody else the core API
 * refuses sees the 403 page.
 */
const CoreServiceRouter = () => {
  const { isAuthenticated } = useAuthenticationService();

  return (
    <ProtectedRouter basePath={CORE_SERVICE_PATH}>
      <CoreServiceAccessGuard>
        <Routes>
          <Route index element={<CoreServicePage />} />
          <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
        </Routes>
      </CoreServiceAccessGuard>
    </ProtectedRouter>
  );
};

CoreServiceRouter.getRouterPath = () => `${CORE_SERVICE_PATH}/*`;

export default CoreServiceRouter;
